/* eslint-disable */
import { BaseProfile } from "../../models/common/base-profile";
import { City } from "../../models/common/city.model";
import { Country } from "../../models/common/country.model";
import { LatLng } from "../../models/common/lat-lng";
import { TransportationAgency } from "../../company/transportation-agency/transportation-agency.model";
import { Vehicle } from "../vehicle/vehicle.model";
import { Location } from "../../location/location.model";

export class Driver extends BaseProfile {
    legalName: string;
    fixedRate?: any;
    tripCount?: any;
    isIDVerified?: any;
    validated?: any;
    membershipDate?: any;
    homeLocation?: Location;
    preferredLocation: LatLng;
    preferredAddress: string;
    licenseNumber: string;
    residenceNumber: string;
    licenseExpiryDate: number | undefined;
    residenceExpiryDate: number | undefined;
    licenseImage: string;
    residenceImage: string;
    motLicenseNumber?: any;
    motLicenseImage?: any;
    legalAgreementAccepted: boolean;
    nationality: Country;
    residingCountry: Country;
    residingCity?: City;
    identityType?: string;
    identityIssueNumber?: number;
    licenseCountry?: Country;
    licenseClass?: string;
    licenseType?: string;
    transportPermitNumber?: string;
    transportPermitExpiryDate?: number | Date;
    transportPermitCountry?: Country;
    currentVehicle?: Vehicle;
    currentTransportationAgency?: TransportationAgency;
    subLocality?: any;
    agencyCrNumber?: any;
    status?: string;
    rentalVendorName?: string;
    rentalStartDate?: number | Date;
    rentalEndDate?: number | Date;
    rentalRateAmount?: number;
    rentalRateCurrency?: string;
    rentalRatePeriod?: string;
    rentalStatus?: string;
    rentalNotes?: string;
    rentalVendorCompanyId?: number;
    rentalContractReferenceNumber?: string;
    rentalDepositAmount?: number;
    rentalDepositCurrency?: string;
    rentalRenewalStatus?: string;
    rentalBillId?: number;
    rentalExpenseId?: number;
    resourceOwnershipType?: string;
    resourceCompanyId?: number;
    resourceCompanyName?: string;
    transporterCrmClientId?: number;
    transporterCrmClientName?: string;
    transporterCrmClientNumber?: string;
    tableRowKey?: string;
}
